// extracted by mini-css-extract-plugin
export default {"main":"register_main__Wmw4p","box":"register_box__IL-oh","icon":"register_icon__oTR0n"};